import { ActivityType } from './ActivityInfo';
import { Body2Reg } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/useStores';




  type ActivityTypeProp = {
    type: ActivityType
  }

const _ActivityInfoText  = ({type}: ActivityTypeProp) => {

  const {language } = useStores();
  const labels = language?.translate?.MOBILE?.LIBRARY?.TYPE_OF_ACTIVITIES;
  return (
    <Body2Reg style={{color: COLORS.content.secondary}}>{labels?.[type]}</Body2Reg>
  );
};


export const ActivityInfoText = observer(_ActivityInfoText);


